export default "__VITE_PUBLIC_ASSET__2a6c8821__"